import React, { useState, useEffect, useMemo } from 'react'
import { Col, Row } from 'react-bootstrap'
import { MapboxPlot } from '../mapboxPlot'
import moment from 'moment';
import { parseFleetName, getNshipFuelData, normalizeToFirstTotalWithRaw} from '../utils/utils';
import Loading from '../views/Loading';
import { useCallback } from 'react';


export const PortDashboard = () => {
    const [year, setYear] = useState(2020);
    const [month, setMonth] = useState(1);
    const [scenario, setScenario] = useState()
    const [region, setRegion] = useState()
    const [scenarioes, setScenarioes] = useState()
    const [regions, setRegions] = useState()
    const [fleets, setFleets] = useState()
    const [fleet, setFleet] = useState()
    const [portsData, setPortsData] = useState()
    const [overallData, setOverallData] = useState()
    const [portsDataSelection, setPortsDataSelection] = useState()
    const [overallDataSelection, setOverallDataSelection] = useState()
    const [descriptionData, setDescriptionData] = useState()
    const [fuelTypeInfo, setFuelTypeInfo] = useState()
    const [overallRouteData, setOverallRouteData] = useState()
    const [routeDataParameter, setRouteDataParameter] = useState()
    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()


    useEffect(() => {
        let url = `${process.env.REACT_APP_SERVER_URL}/fuel_type_info`
        fetch(url)
            .then((response) => response.json())
            .then((data) => setFuelTypeInfo(data))
            .catch((error) => console.error(error))

        url = `${process.env.REACT_APP_SERVER_URL}/regions_meta`
        fetch(url)
            .then((response) => response.json())
            .then((data) => setRegions(data.regions))
            .catch((error) => console.error(error))
    },
        [])

    useEffect(() => {
        if (!!regions) {
            let startRegion = regions[0]
            setRegion({ ...startRegion })
        }
    },
        [regions])

    useEffect(() => {

        if (!!region) {
            let url = `${process.env.REACT_APP_SERVER_URL}/scenarioes_meta/${region.id}`

            // let url = `${process.env.REACT_APP_SERVER_URL}/region_data`
            // console.log(process.env)
            // console.log(url)
            fetch(url)
                .then((response) => response.json())
                .then((data) => { setScenarioes(data); setScenario({ ...data[0] }) })
                .catch((error) => console.error(error))
        }
    }, [region]);


    useEffect(() => {
        if (!!scenario) {
            let url = `${process.env.REACT_APP_SERVER_URL}/scenario_ports_data/${scenario.id}`
            fetch(url)
                .then((response) => response.json())
                .then((data) => setPortsData(data))
                .catch((error) => console.error(error))

            url = `${process.env.REACT_APP_SERVER_URL}/scenario_overall_data/${scenario.id}`
            fetch(url)
                .then((response) => response.json())
                .then((data) => setOverallData(data))
                .catch((error) => console.error(error))

            url = `${process.env.REACT_APP_SERVER_URL}/scenario_description_data/${scenario.id}`
            fetch(url)
                .then((response) => response.json())
                .then((data) => setDescriptionData(data))
                .catch((error) => console.error(error))

            url = `${process.env.REACT_APP_SERVER_URL}/route_data/${scenario.id}`
            fetch(url)
                .then((response) => response.json())
                .then((data) => setOverallRouteData(data))
                .catch((error) => console.error(error))

        }
    }, [scenario]);

    useEffect(() => {
        if (!!portsData) {
            let selected_data = portsData.data.filter(d => d.year === year && d.month === month && d.name !== "")
            selected_data = selected_data.sort((a, b) => b.TOTAL - a.TOTAL)
            selected_data = selected_data.map(s => { return { ...s, fraction: s.TOTAL / portsData.max_TOTAL } })
            setPortsDataSelection(selected_data)
        }
    }, [year, month, portsData]);

    const fleetNameFormatter = (fleet, portData) => {
        const fleetnameobj = parseFleetName(fleet, portData)
        if (fleetnameobj.portA && fleetnameobj.portB) {
            return `${fleetnameobj.shiptype} - ${fleetnameobj.portA} - ${fleetnameobj.portB}`
        } else {
            return fleetnameobj.shiptype
        }
    }

    

    const refineData = useCallback((overallData, ft) => { // todo: revamp to create the proper data
        overallData = overallData.map(el => ({ ...el, opex: ft.map((item) => (el.consumption[item.name]?el.consumption[item.name] * 1000 * el.fuel_price[item.name]:0)).reduce((a, b) => a + b, 0) }))
        overallData = overallData.reduce((arr, obj, idx) => {
            if (idx === 0) {
                arr.push({ ...obj, opex_cumsum: obj['opex'] })
            } else {
                const last = arr[idx - 1];
                arr.push({ ...obj, opex_cumsum: last['opex_cumsum'] + obj['opex'] })
            }
            return arr

        }, [])
        
        overallData = overallData.map(el => ({ ...el, el_energy: ft.map(fitem => ((fuelTypeInfo[fitem.name].prod_efficiency_elec && el.consumption[fitem.name]) ? el.consumption[fitem.name] / 1000 / fuelTypeInfo[fitem.name].prod_efficiency_elec : 0)).reduce((a, b) => a + b, 0) }))
        
                
        const nshipKey = (r) =>
        r.name; // already YYYY-MM
        
  
        const nshipFuelData =
        normalizeToFirstTotalWithRaw(
            getNshipFuelData(overallData),
            ft
        );

        const nshipByKey = Object.fromEntries(
        nshipFuelData.map(item => [nshipKey(item), item])
        );

        overallData = overallData.map(row => ({
            
        ...row,
        techshare: nshipByKey[`${row.year}-${row.month}`]
            ? nshipByKey[`${row.year}-${row.month}`]
            : []
        }));
        
        return overallData
    }, [fuelTypeInfo])


    useEffect(() => {
        if (!!overallData && !!portsData) {
            const _sd = moment({ year: overallData.data[0].year, month: overallData.data[0].month - 1 })
            const _ed = moment({ year: overallData.data[overallData.data.length - 1].year, month: overallData.data[overallData.data.length - 1].month - 1 })
            setStartDate(_sd)
            setEndDate(_ed)
            setOverallDataSelection(refineData(overallData.data, overallData.fueltypes))
            if (overallData.fleet_data && portsData.data) {
                setFleets([{ id: 0, name: 'All', fleet: 'all' }].concat(Object.keys(overallData.fleet_data).map((el, idx) => ({ id: idx + 1, name: fleetNameFormatter(el, portsData.data), fleet: el }))))
                setFleet({ id: 0, name: 'All', fleet: 'all' })
            } else {
                setFleets(undefined)
                setFleet({ id: 0, name: 'All', fleet: 'all' })
            }
        }
    }, [overallData, portsData, refineData]);


    useEffect(() => {
        if (!!overallRouteData && !!overallRouteData.parameters) {
            setRouteDataParameter(overallRouteData.parameters[0])
        }
    }, [overallRouteData]);


    const routeData = useMemo(() => {
        if (!!overallRouteData && !!routeDataParameter && !!overallRouteData.features) {
            let data = overallRouteData.features.map(f => {
                if (year in f.properties[routeDataParameter.name]) {
                    const value = f.properties[routeDataParameter.name][year][month - 1];
                    const properties = { value: value }
                    return { ...f, properties };
                } else {
                    return { ...f };
                }
            }
            );

            data = data.sort((a, b) => a.properties.value - b.properties.value)
            data = { ...overallRouteData, features: data }
            return data
        }
    }, [overallRouteData, routeDataParameter, year, month])

    useEffect(() => {
        if (!!fleet) {
            if (fleet.fleet !== 'all') {
                const data = overallData.fleet_data[fleet.fleet]
                setOverallDataSelection(refineData(data, overallData.fueltypes))
            } else {
                setOverallDataSelection(refineData(overallData.data, overallData.fueltypes))
            }
        }
    }, [fleet, overallData, refineData])


    useEffect(() => {
        if (!!overallData && !!portsData) {
            let selected_data = portsData.data.filter(d => d.year === year && d.month === month && d.name !== "")
            selected_data = selected_data.sort((a, b) => b.TOTAL - a.TOTAL)
            selected_data = selected_data.map(s => { return { ...s, fraction: s.TOTAL / portsData.max_TOTAL } })
            setPortsDataSelection(selected_data)
        }
    }, [month, overallData, portsData, year]);

    if (!!!region) return <Loading text="Loading regions..." />
    if (!!!portsData) return <Loading text="Loading region - all ports data..." />
    if (!!!portsDataSelection) return <Loading text="Loading selected port data..." />
    if (!!!overallDataSelection) return <Loading text="Loading chart data..." />
    if (!!!fuelTypeInfo) return <Loading text="Loading fuel data..." />
    if (!!!overallRouteData) return <Loading text="Loading route data..." />
    if (!!!routeDataParameter) return <Loading text="Loading route data..." />

    return (
        <React.Fragment>
            <Row style={{ marginRight: 0 }}>
                <Col>
                    <MapboxPlot data={portsDataSelection} max_TOTAL={portsData.max_TOTAL} scenario={scenario}
                        setScenario={setScenario} scenarioes={scenarioes} setScenarioes={setScenarioes}
                        overallData={overallDataSelection} overallFueltypes={overallData.fueltypes}
                        portsFueltypes={portsData.fueltypes} portsData={portsData}
                        month={month} setMonth={setMonth} year={year} setYear={setYear} descriptionData={descriptionData}
                        fuelTypeInfo={fuelTypeInfo}
                        regions={regions} region={region} setRegion={setRegion}
                        routeData={routeData}
                        routeDataParameters={overallRouteData.parameters} routeDataParameter={routeDataParameter} setRouteDataParameter={setRouteDataParameter}
                        startDate={startDate} endDate={endDate} fleets={fleets} fleet={fleet} setFleet={setFleet} />
                </Col>
            </Row>
        </React.Fragment>
    )

}